export const ROLES = {
  admin: {
    label: "Admin",
    role: "a2470ee4",
  },
  hotelchain_admin: {
    label: "Admin de Cadena",
    role: "a2470ee5",
  },
  hotel_admin: {
    label: "Admin de Hotel",
    role: "a2470ee6",
  },
};

export const ROLES_RAW = Object.values(ROLES).map((r) => r.role);

export const ROLE_OPTS = Object.values(ROLES).map((r) => ({
  label: r.label,
  value: r.role,
}));
